AgrimarketControllers.controller('DisconnectController', ['$scope', '$rootScope', '$http', '$location', 'currentUserFactory',
    function ($scope, $rootScope, $http, $location, currentUserFactory) {

        $rootScope.currentUserRole = '';
        currentUserFactory.User = null;
        currentUserFactory.Connection = null;
        $rootScope.isLogged = false;
        $rootScope.loading = false;

        $rootScope.$broadcast("$destroy");
        if (sessionStorage.getItem("GRAINBOW_TOKEN") && sessionStorage.getItem("ConnectedToGrainbow")) {
            sessionStorage.clear();
            $location.path("/grainbow");
        } else if (sessionStorage.getItem("isAdmin")) {
            sessionStorage.clear();
            $location.path("/loginAdmin");
        } else {
            sessionStorage.clear();
            $location.path('/login');
        }
    }]);
